<template>

<div class="meta">

	<span class="meta-no">Day #{{ number }}</span>

	<span class="meta-stats">
		<span>TILES {{ tilesRevealed }}/16</span>
		<span class="meta-dot">·</span>
		<span>GUESSES {{ guessesUsed }}/16</span>
	</span>

</div>

</template>

<script>

/*
	The puzzle meta line, in IBM Plex Mono and muted: the puzzle number plus the
	live "TILES x/16 · GUESSES x/16" counters. We use /16 (not the design
	export's /6): the boxart mechanic is 16 tiles and 16 guesses, one tile per
	wrong guess. Both counters read straight off the store getters — never
	recomputed — so they stay server-authoritative.
*/

export default {

	computed: {

		number: function() {

			var today = this.$store.getters['game/today']

			return (today && (today.number != null ? today.number : today.no)) || '—'

		},

		tilesRevealed: function() {

			return this.$store.getters['game/tilesRevealed']

		},

		guessesUsed: function() {

			return this.$store.getters['game/guessesUsed']

		}

	}

}

</script>

<style scoped>

.meta {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 12px;
	font-family: var(--font-mono);
}

.meta-no {
	font-size: 12px;
	letter-spacing: 0.08em;
	color: var(--ink);
}

.meta-stats {
	display: flex;
	align-items: baseline;
	gap: 6px;
	font-size: 10.5px;
	letter-spacing: 0.06em;
	color: var(--muted);
}

.meta-dot {
	color: var(--tile);
}

</style>
